import { Directive } from '@angular/core';

@Directive({
  selector: '[appMessageCardDescription]',
  standalone: true,
})
export class MessageCardDescriptionDirective {}
